export interface ILoginMetaData {
  userName: string;
  password: string;
}

export interface IForgetPasswordMeteData {
  userName: string;
  reqId: string;
}

export interface IAuthStore {
  resetState: () => void;
  step: IAuthStepEnum;
  setStep: (state: IAuthStepEnum) => void;
  forgetPasswordMeteData: IForgetPasswordMeteData;
  setForgetPasswordMeteData: (state: IForgetPasswordMeteData) => void;
}

export enum IAuthStepEnum {
  LOGIN = "login",
  RESET_PASSWORD = "reset-password",
  SIGNUP = "signup",
  // eslint-disable-next-line @typescript-eslint/no-mixed-enums
  CHECK_RESET_PASSWORD_VERIFICATION = 0,
  CHECK_SIGN_UP_EMAIL_VERIFICATION,
  SET_NEW_PASSWORD,
}
